export default {
	methods: {
		async updateStepsFromMyWorkflowInit() {
			const myWorkflow = this.$store.state.myWorkflow || this.getMyWorkflowFromLocalStorage();
			const {
				data: {workflow_steps},
			} = await myWorkflow;

			await this.$store.dispatch('restoreWorkflow/restoreWfs', workflow_steps);
			this.isMissingWorkflowProducts();

			// trigger snackbar if content as changed from country availability
			if (this.$store.getters['restoreWorkflow/countryAvailabilityChanged']) {
				this.$root.$emit('countryAvailabilityChanged');
				this.$store.dispatch('restoreWorkflow/setCountryAvailabilityChanged', false);
			}

			this.resetMyWorflowState();
		},
		getMyWorkflowFromLocalStorage() {
			const myWfId = this.getPropertyFromLocalStorage('myWfId');
			return JSON.parse(localStorage.getItem('lsMyWorkflows'))?.workflows.find((lsWf) => lsWf.id === myWfId);
		},
		async resetMyWorflowState() {
			await this.$store.commit('setMyWorkflow', null);
			await this.$store.commit('setMyWorkflows', null);
		},
		isMissingWorkflowProducts() {
			// checks and shows banner if restored workflow has missing products

			const banner = {
				title: 'Your Experiment has Missing Products',
				version: 'warning',
				body: '',
				dismissible: true,
				layout: 'html',
			};

			const {missing, found} = this.$store.getters['restoreWorkflow/getMissingProducts'];
			const foundVals = Object.values(found);

			if (missing.size > 0) {
				const plural = missing.size > 1 ? ['products', 'steps:', 'have', ''] : ['a product', 'step', 'has'];

				banner.body = `<p class="missing-product">Your saved experiment
				has ${plural[0]} on ${plural[1]} ${[...missing].join(', ')} that ${plural[2]} now
				been removed. Please select another product for that step.<p>`;
			}

			if (foundVals?.length) {
				// has multipal steps or products for a step
				if (foundVals.length > 1 || foundVals[0].products?.length > 1) {
					const steps = [];
					const prods = [];

					for (const {name, products} of foundVals) {
						steps.push(name);
						for (const {catalogNumber, description} of products)
							prods.push(
								`<li>CAT. NO ${catalogNumber}: ${description.replace(/(<([^>]+)>)/gi, '')}</li>`,
							);
					}

					const multiSteps = steps.length > 1 ? ['steps:', 'these steps'] : ['step', 'that step'];

					banner.body = `${banner.body}<p class="missing-product">Your saved experiment has products on
					${multiSteps[0]} ${steps.join(', ')} that have
					 now been removed:  <ul class="missing-product" style="padding-left:20">${prods.join('')}</ul>
					Please select other products for ${multiSteps[1]}.</p>`;
				} else {
					// more than one value
					const {name, products} = foundVals[0];
					banner.body = `${
						banner.body
					}<p class="missing-product">Your saved experiment has a product on step ${name} that
					has now been removed: CAT. NO. ${products[0].catalogNumber} - ${products[0].description.replace(/(<([^>]+)>)/gi, '')}.
					Please select another product for that step.</p>`;
				}
			}
			if (banner.body?.length) {
				this.$root.$emit('showGlobalBanner', banner);
			}
		},
	},
};
